import React from "react"
import "./index.css"

const Accordian = React.memo(({ children, show, maxHeight }) => {
    return <div className={`accord-main ${show?'show':''}`} style={{ maxHeight: show?maxHeight||'30vw':'0' }}>{children}</div>
})

export default Accordian